"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3614],{

/***/ 23614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CardByLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87771);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52091);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var src_utils_countview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55853);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39334);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(186);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1903);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(477);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  :hover {\n    img {\n      transform: scale(1.15);\n    }\n  }\n  .card-title {\n    font-size: 22pt;\n    font-weight: 500;\n    line-height: 1;\n    margin: 10px 0;\n    letter-spacing: 0;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n    color: var(--text-color);\n    min-height: 56px;\n    /* height: 56px; */\n    @media (max-width: 767px) {\n      margin: 10px 0px 0px;\n      font-size: 20pt;\n      min-height: 64px;\n      -webkit-line-clamp: 3 !important;\n    }\n  }\n  .card-image {\n    position: relative;\n    overflow: hidden;\n    border-radius: 8px;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      aspect-ratio: 16 / 9;\n      transition: all 1s ease-out;\n    }\n  }\n  .card-blurb {\n    font-size: 20pt;\n    font-weight: 300;\n    color: var(--primary-gray);\n    line-height: 1.15;\n    font-family: 'DBHelvethaica', sans-serif;\n  }\n  .meta-badge {\n    padding: 2px 10px;\n    background-color: var(--secondary-gray);\n    color: var(--white-color);\n    font-size: 16pt;\n    border-radius: 0 8px 0 8px;\n    margin-right: 10px;\n  }\n  .byline {\n    font-size: 12pt;\n    font-weight: 300;\n    color: var(--black-color);\n    margin-top: 15px;\n  }\n  .footer {\n    margin-top: 10px;\n  }\n  .date-publish {\n    &--icon {\n      margin-right: 4px;\n      margin-bottom: 2px;\n    }\n    &--icon,\n    small {\n      text-transform: lowercase;\n      font-size: 16pt;\n      font-weight: 200;\n      line-height: 1;\n      color: #707070;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function CardByLine(param) {
    var data = param.data, _showH2 = param.showH2, showH2 = _showH2 === void 0 ? false : _showH2, _className = param.className, className = _className === void 0 ? "" : _className, _showBadge = param.showBadge, showBadge = _showBadge === void 0 ? true : _showBadge, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, _showBlurb = param.showBlurb, showBlurb = _showBlurb === void 0 ? true : _showBlurb, _showByline = param.showByline, showByline = _showByline === void 0 ? false : _showByline, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage, _showPublishDate = param.showPublishDate, showPublishDate = _showPublishDate === void 0 ? false : _showPublishDate, _showCountView = param.showCountView, showCountView = _showCountView === void 0 ? false : _showCountView, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? false : _showFooter, imageLoading = param.imageLoading, imageDecoding = param.imageDecoding, imageFetchPriority = param.imageFetchPriority, imageWidth = param.imageWidth, imageHeight = param.imageHeight, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _external = param.external, external = _external === void 0 ? false : _external, _path = param.path, path = _path === void 0 ? "" : _path, size = param.size;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(data)) return null;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), countView = ref[0], setCountView = ref[1];
    var conditionCountview = showCountView && Number(countView) > Number(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .NEXT_PUBLIC_DEFAULT_COUNT_VIEW */ .d$);
    var conditionBadge = showBadge && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .convertBadge */ .lC)(data, false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var _pageviews, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,src_utils_countview__WEBPACK_IMPORTED_MODULE_5__/* .useCountviews */ .e)(data)
                        ];
                    case 1:
                        _pageviews = _state.sent();
                        setCountView(_pageviews);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error("".concat((0,src_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .timestamp */ .AB)(), " ==========> CARD_FULL ERROR :"), err.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        data
    ]);
    var href = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return "".concat((data === null || data === void 0 ? void 0 : data.link) || path);
    }, [
        data,
        path
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardWrapper, {
        className: "card-byline ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            title: data === null || data === void 0 ? void 0 : data.title,
            href: href,
            tabIndex: -1,
            eventDataLayer: eventDataLayer,
            children: [
                showImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "card-image",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        external: external,
                        src: data === null || data === void 0 ? void 0 : data.image,
                        alt: data === null || data === void 0 ? void 0 : data.title,
                        title: data === null || data === void 0 ? void 0 : data.title,
                        size: size !== null && size !== void 0 ? size : _image__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_SIZE.MD_WEBP */ .W.MD_WEBP,
                        width: imageWidth,
                        height: imageHeight,
                        loading: imageLoading,
                        decoding: imageDecoding,
                        fetchPriority: imageFetchPriority
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "card-content",
                    children: [
                        showTitle && (showH2 === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: "card-title text-excerpt-2",
                            children: data === null || data === void 0 ? void 0 : data.title
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            className: "card-title text-excerpt-2",
                            children: data === null || data === void 0 ? void 0 : data.title
                        })),
                        showBlurb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: "card-blurb text-excerpt-3",
                            children: data === null || data === void 0 ? void 0 : data.blurb
                        })
                    ]
                }),
                showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "card-footer flex-between",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "footer-left",
                        children: [
                            showByline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: data.byline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "byline",
                                    children: "By [".concat(data.byline, "]")
                                })
                            }),
                            conditionCountview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "count-view",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaRegEye */ .z5B, {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                        children: (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .numeralFormat */ .EL)(countView)
                                    })
                                ]
                            })
                        ]
                    })
                }),
                showPublishDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "footer --item date-publish",
                    children: [
                        conditionBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "meta-badge",
                            children: conditionBadge
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_12__/* .AiOutlineClockCircle */ .cjn, {
                                    size: 16,
                                    className: "date-publish--icon"
                                }),
                                (data === null || data === void 0 ? void 0 : data.published_at) && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .useDateUpdate */ .WR)(data.published_at, true)
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject());


/***/ }),

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 55853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ useCountviews; }
});

// UNUSED EXPORTS: incrementCountview

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/constants/layout.js
var layout = __webpack_require__(38864);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(39334);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/countview/fetch-with-timeout.js




function fetchWithTimeout(resource, options) {
    return _fetchWithTimeout.apply(this, arguments);
}
function _fetchWithTimeout() {
    _fetchWithTimeout = (0,_async_to_generator/* default */.Z)(function(resource, options) {
        var _timeout, timeout, controller, action, response, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _timeout = options.timeout, timeout = _timeout === void 0 ? 1000 : _timeout;
                    controller = new AbortController();
                    action = setTimeout(function() {
                        return controller.abort();
                    }, timeout);
                    _tmp = {};
                    _tmp1 = {};
                    return [
                        4,
                        fetch(resource, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, options), (_tmp1.signal = controller.signal, _tmp1)))
                    ];
                case 1:
                    response = _state.sent();
                    clearTimeout(action);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _fetchWithTimeout.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/utils/countview/index.js








// for page detail
var incrementCountview = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_article) {
        var increase, _ga, _gid, params, _tmp, uri, res, _tmp1, resData, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!_article) return [
                        2,
                        0
                    ];
                    increase = 0;
                    _ga = js_cookie/* default.get */.Z.get("_ga");
                    _gid = js_cookie/* default.get */.Z.get("_gid");
                    _tmp = {};
                    params = (_tmp.site = layout/* WEB_NAME */.Ey, _tmp.ga = _ga || "", _tmp.gid = _gid || "", _tmp.newsid = _article.id || "", _tmp);
                    uri = "".concat(constants/* CLIENT_GSERVICE_URL */.Tr, "/cpvs");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    _tmp1 = {};
                    return [
                        4,
                        fetch(uri, (_tmp1.method = "POST", _tmp1.headers = {
                            "Content-Type": "application/json"
                        }, _tmp1.body = JSON.stringify(params), _tmp1))
                    ];
                case 2:
                    res = _state.sent();
                    if (!lodash_default().isEmpty(res)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    resData = _state.sent();
                    // console.log('pageviews :', resData, Number(resData), Number(_article.pageviews || 0));
                    increase = Number(resData) + Number(_article.pageviews || 0);
                    // console.log('increase :', increase);
                    return [
                        2,
                        increase
                    ];
                case 4:
                    return [
                        2,
                        Number(0)
                    ];
                case 5:
                    err = _state.sent();
                    console.warn("".concat((0,helper/* timestamp */.AB)(), "==========> INCREMENT_COUNTVIEWS ERROR : ").concat(uri), err);
                    return [
                        2,
                        Number(0)
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function incrementCountview(_article) {
        return _ref.apply(this, arguments);
    };
}();
// for card
var useCountviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_article) {
        var increase, _ga, _gid, params, _tmp, uri, res, _tmp1, resData, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!_article) return [
                        2,
                        0
                    ];
                    increase = 0;
                    _ga = js_cookie/* default.get */.Z.get("_ga");
                    _gid = js_cookie/* default.get */.Z.get("_gid");
                    _tmp = {};
                    params = (_tmp.site = layout/* WEB_NAME */.Ey, _tmp.ga = _ga || "", _tmp.gid = _gid || "", _tmp.newsid = _article.id || "", _tmp);
                    uri = "".concat(constants/* CLIENT_GSERVICE_URL */.Tr, "/cpvs");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp1 = {};
                    return [
                        4,
                        fetchWithTimeout("".concat(constants/* CLIENT_GSERVICE_URL */.Tr, "/cpvs").concat((0,helper/* convertObjPath */.lJ)(params)), (_tmp1.timeout = 1000, _tmp1))
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    resData = _state.sent();
                    // console.log('Increment pageviews : ', Number(resData || 0), '+', Number(_article.pageviews || 0), '=', Number(resData || 0) + Number(_article.pageviews || 0));
                    increase = Number(resData) + Number(_article.pageviews || 0);
                    // console.log('increase :', increase);
                    return [
                        2,
                        increase
                    ];
                case 4:
                    err = _state.sent();
                    console.warn("".concat((0,helper/* timestamp */.AB)(), "==========> GET_COUNTVIEWS ERROR : ").concat(uri), err);
                    return [
                        2,
                        Number(0)
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function useCountviews(_article) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);